<template>
  <div class="warehouse-no-input">
    <el-tooltip placement="bottom-end" style="flex: 1">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <el-input v-if="disabled" :disabled="disabled" :value="multiLineLabel" class="overflow-ellipsis" />
      <el-input v-else v-model="firstLineVal" @blur="firstLineValBlur" />
    </el-tooltip>
    <el-tooltip class="item" placement="bottom-end" :disabled="disabled">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <span class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" type="primary" @click="showDialog=true">{{ finalRowData.length }}</span>
    </el-tooltip>

    <el-form>
      <!-- 多行输入对话框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="showDialog"
        :title="$t('SeaExport.WarehouseNo')+$t('SeaExport.Select')"
        width="450px"
        :show-close="false"
        append-to-body
        :close-on-click-modal="false"
        class="app-main-inner"
      >
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="finalRowData"
          :auto-fit-content="false"
          style="width:100%;height:300px"
          @gridReady="params=>{gridApi=params.api}"
        />
        <span slot="footer" style="display: flex;justify-content: space-between;">
          <div v-show="!disabled">
            <el-button type="primary" @click="add">{{ $t('Payment.new') }}</el-button>
            <el-button type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          </div>
          <div style="flex: 1;text-align: right;">
            <label @click="save">
              <el-button v-show="!disabled" class="is-enabled" type="primary">{{ $t('common.btn.confirm') }}</el-button>
              <el-button v-if="disabled" @click="showDialog=false">{{ $t('common.btn.close') }}</el-button>
            </label>
          </div>
        </span>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'

export default {
  name: 'WarehouseNoInput',
  components: { },
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    jobWarehouseNos: { type: Array, default: () => [] },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerValue: '',
      firstLineVal: '', // 第一行的值
      showDialog: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        suppressCellSelection: true,
        suppressRowSelection: false,
        suppressRowClickSelection: false,
        rowHeight: 32,
        frameworkComponents: { CargoAgGridCommonInputEditor },
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: p => {
          this.rowClicked(p)
        }
      },
      rowData: [],
      gridApi: null,
      selectedWarehouseNo: null,
      tooltip: ''
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('Order.WarehouseNo'),
          field: 'warehouseNo',
          suppressMenu: true,
          width: 200,
          editable: !this.disabled,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 400
            }
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantity',
          width: 200,
          editable: !this.disabled,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              maxLength: 400
            }
          }
        }
      ]
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    multiLineLabel() {
      if (this.finalRowData.length > 1) {
        return Array.from(this.finalRowData, p => p.warehouseNo).join(',')
      }
      return this.firstLineVal
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.onShow()
      }
    },
    value(newVal) {
      this.innerValue = newVal
      this.toRowData()
      this.tooltip = newVal ? newVal.replace(',', '<br/>') : ''
    },
    firstLineVal(newVal) {
      let flag = true // 表示行数据是否都打上了删除标记，或者行数据为空
      if (this.rowData.length > 0) {
        for (let i = 0; i <= this.rowData.length - 1; i++) {
          if (!this.rowData[i].deleted) {
            this.rowData[i].warehouseNo = newVal
            flag = false
            break
          }
        }
      }
      if (newVal && flag) {
        this.rowData.push({ warehouseNo: newVal })
      }
      this.save()
    },
    showDialog(newVal) {
      if (!newVal) {
        this.save()
      } else {
        this.toRowData()
      }
    },
    jobWarehouseNos(newVal) {
      this.rowData = newVal
      this.setFirstLineVal()
    }
  },
  created() {
    if (this.value) {
      this.toRowData()
      this.tooltip = this.value.replace(',', '<br/>')
    }
  },
  methods: {
    async toRowData() {
      this.rowData = this.jobWarehouseNos
      this.setFirstLineVal()
    },
    rowClicked(event) {
      if (event) {
        this.selectedWarehouseNo = event.data
      }
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedWarehouseNo = node.data
          }
        })
      }
    },
    add() {
      this.rowData.push({ warehouseNo: '' })
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
        this.selectedWarehouseNo = lastNode.data
      })
    },
    remove() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length && this.rowData) {
        for (let i = this.rowData.length - 1; i >= 0; --i) {
          const row = this.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              row.deleted = true
            } else {
              this.rowData.splice(i, 1)
            }
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
    },
    save() {
      if (this.disabled) {
        this.showDialog = false
        return
      }
      let warehouseNo = ''

      if (this.rowData && this.rowData.length > 0) {
        this.rowData = this.rowData.filter(p => p.warehouseNo.trim() !== '')
      }

      for (const item of this.rowData) {
        // 过滤空字符串
        if (!item.warehouseNo.trim() || item.deleted) {
          continue
        }
        if (warehouseNo) {
          warehouseNo += ','
        }
        warehouseNo += item.warehouseNo.trim()
      }

      this.tooltip = warehouseNo.replace(',', '<br/>')
      this.setFirstLineVal()
      this.innerValue = warehouseNo
      this.$emit('update:jobWarehouseNos', this.rowData)
      this.$emit('input', warehouseNo)
      this.showDialog = false
    },
    firstLineValBlur() { // 焦点离开，判断是否有值，有的话对数据做去两边空格处理
      if (this.firstLineVal) {
        this.firstLineVal = this.firstLineVal.trim()
      }
    },
    setFirstLineVal() {
      // 先排序,保持显示的顺序与业务上存储的进仓编号顺序一致
      // if (this.value) {
      //   const warehouseNos = this.value.split(',')
      //   this.rowData.sort((a, b) => {
      //     return warehouseNos.indexOf(a.warehouseNo) - warehouseNos.indexOf(b.warehouseNo)
      //   })
      // }
      this.firstLineVal = ''
      for (let i = 0; i <= this.rowData.length - 1; i++) {
        const row = this.rowData[i]
        if (!row.deleted) {
          this.firstLineVal = row.warehouseNo
          break
        }
      }
    },
    onCellChange(params) {
      if (params.colDef.field === 'warehouseNo' && params.data['warehouseNo']) {
        params.data['warehouseNo'] = params.newValue.trim()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-no-input {
  display: flex;
  flex-direction: row;
  padding-right: 3px;
  .ag-header {
    display: none;
  }
  .is-enabled {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
    cursor: pointer;
  }
  .overflow-ellipsis ::v-deep {
    .el-input__inner {
      text-overflow: ellipsis;
    }
  }
}
</style>
